import React, { FunctionComponent } from 'react';
import { ProGalleryField } from '../pro-gallery-field';

const ProGalleryRoute: FunctionComponent = () => {
  return <ProGalleryField name="proPresentation.proMediaObjects" />;
};

export default ProGalleryRoute;
